import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Form from 'react-bootstrap/Form';
import { getApiData } from '../apiFunctions/getApiData';
import * as Constants from '../constants';
import { LicenseKey } from '../types/LicenseKey';
import { ErrorAlert } from './generic/ErrorAlert';
import { LoadingSpinner } from './generic/LoadingSpinner';

export const CheckSerialNumberLicense: React.FC = props => {
    const [serialNumber, setSerialNumber] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [licenseKey, setLicenseKey] = useState<LicenseKey>();

    const setData = (licenseKey: LicenseKey) => {
        if (!licenseKey.code) {
            setErrorMessage("Serial number not found.");
            setLicenseKey(undefined);
        } else {
            setErrorMessage("");
            setLicenseKey(licenseKey);
        }
    }

    const getLicenseCode = () => {
        getApiData(Constants.API_LICENSE_KEY_URL + "/" + encodeURIComponent(serialNumber), setLoading, setData, setErrorMessage);
    }

    return <React.Fragment>
        {loading && <LoadingSpinner />}
        {!loading && errorMessage !== "" && <ErrorAlert errorMessage={errorMessage} />}
        {!loading && <Form className="mt-3">
            <Form.Group className="mb-3" controlId="serialNumber">
                <Form.Control type="text" placeholder="T26107ABCD"
                    defaultValue={serialNumber}
                    onChange={(e: any) => {
                        setSerialNumber(e.currentTarget.value);
                    }} />
            </Form.Group>

            <Button className="button" disabled={serialNumber.length === 0} onClick={() => { getLicenseCode() }}>
                Check
            </Button>
        </Form>}
        {licenseKey && <Alert className="mt-3">
            <p className="fw-bold">{licenseKey.itemDescription}</p>
            License key:
            <p className="fst-italic">{licenseKey.code.match(/.{1,4}/g)?.join(' ')}</p>
        </Alert>}
    </React.Fragment>;
}